import * as React from 'react';
import { store } from './createStore';
import Main from './main';
import GlobalStyles from '@mui/material/GlobalStyles';
import './components/details/pages/agenda/DatePicker.css';
import './components/details/pages/agenda/Calendar.css';
import './components/details/pages/images/lightbox-style.css';

// Sync loading of store
class App extends React.Component {
  public render() {
    return (
      <div style={{height: '100%'}}>
        <GlobalStyles
          styles={{
            'input': {
              padding: '0px 0px 0px 4px !important',
            },
            '.MuiSelect-select': {
              padding: '2px 32px 0px 4px  !important',
              border: 'none !important',
            },
            '.MuiOutlinedInput-notchedOutline': {
              border: 'none !important',
            },
          }}
        />
        <Main store={store}/>
      </div>
    );
  }
}

export default App;
